import styles from './ApprovedTransaction.module.css'
import { IconButton } from '@/components/IconButton'
import { Icon } from '@/components/Icon'
import { formatTransactionReason } from '@/features/payouts/transaction-formatters'
import {
  DropdownItem,
  DropdownItemTitle,
  Dropdown,
  DropdownTitle,
} from '@/components/Dropdown'
import { Amount } from '@/features/payouts/components/Amount'
import type { TransactionSourceType } from '@/features/payouts/transaction-source-type'
import { match } from '@/utils/pattern-match-util'
import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'

export interface ApprovedTransactionProps {
  isDisabled: boolean
  isPending: boolean
  recipientName: string
  amount: number
  source: TransactionSourceType
  reason: UserTransactionReason | null
  jobId: string | null
  onRemove: () => unknown
}

export function ApprovedTransaction({
  isDisabled,
  isPending,
  recipientName,
  amount,
  source,
  reason,
  jobId,
  onRemove,
}: ApprovedTransactionProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.info}>
          <div className={styles.title}>
            <div className={styles.recipient}>{recipientName}</div>

            <div className={styles.amount}>
              <Amount value={amount} />
            </div>
          </div>
          <div className={styles.subtitle}>
            {match(source, {
              User: () => <>{formatTransactionReason(reason)}</>,
              Job: () => (
                <>
                  Job payout
                  <div className={styles.identifier}>{jobId}</div>
                </>
              ),
              Unknown: () => <>Unknown Source Type</>,
            })}
          </div>
        </div>
        <div className={styles.actions}>
          <Dropdown
            autoDismiss
            isDisabled={isDisabled}
            button={
              <IconButton
                name="more"
                label="Transaction actions"
                isPending={isPending}
                isDisabled={isDisabled}
              />
            }
          >
            <DropdownTitle>Actions</DropdownTitle>
            <DropdownItem icon={<Icon name="close" />} onPress={onRemove}>
              <DropdownItemTitle>Remove</DropdownItemTitle>
            </DropdownItem>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}
